var module = angular.module('octopusApp.projects');

module.directive('azureServerTargetrolesInfo', function () {
    return {
        restrict: 'E',
        replace: true,
        templateUrl:'areas/projects/views/azure_server_targetroles_info.html'
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/azure_server_targetroles_info.js
// module id = 2724951305218979
// module chunks = 1